import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const articleCategoriesSlice = createSlice({
  name: "articleCategories",
  initialState,
  reducers,
});